import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {ButtonWithIcon, Icon} from '@/components/atoms';
import {COLOR} from '@/utils/constants/colors';
import {SIZE} from '@/utils/constants/globalStyle';
import {useIntl} from 'react-intl';

/**
 * FileTransferButton component for upload and download actions
 * @param {object} props - Component props
 * @param {boolean} props.isUpload - If true, renders upload button; otherwise download button
 * @param {Function} props.onClick - Click handler function
 * @returns {React.ReactElement} - The FileTransferButton component
 */
const FileTransferButton = ({isUpload, onClick}) => {
  const {formatMessage} = useIntl();

  const icon = useMemo(() => (isUpload ? 'upload' : 'download'), [isUpload]);
  const messageId = useMemo(
    () => (isUpload ? 'GENERAL.UPLOAD' : 'GENERAL.DOWNLOAD'),
    [isUpload]
  );
  const buttonId = useMemo(
    () => (isUpload ? 'upload-button' : 'download-button'),
    [isUpload]
  );

  const title = formatMessage({id: messageId});

  return (
    <ButtonWithIcon
      id={buttonId}
      handleButton={onClick}
      iconLeading={<Icon icon={icon} size='small' />}
      uiSchema={{
        title,
        size: SIZE.SMALL,
        isDark: true,
        variant: COLOR.TERTIARY
      }}
      data-testid={buttonId}
    />
  );
};

FileTransferButton.propTypes = {
  isUpload: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default React.memo(FileTransferButton);
